export enum ENUM__field_role {
  IMAGE__MAIN = '🖼️ Image Main',

  IMAGE__OUT_AR_WIDTH = '📏 Image Out AR Width',
  IMAGE__OUT_AR_HEIGHT = '📏 Image Out AR Height',
  IMAGE__OUT_AR_REFERENCE = '🖼️ Image Out AR Reference',

  MODEL = '📦 Model',
  MODEL_NAME = '📦 Model Name',

  MODEL__UPSCALER = '📦 Upscaler Model',
  MODEL__UNET = '📦 Unet Model',
  MODEL__VAE_ENCODER = '📦 VAE Model Encoder',
  MODEL__VAE_DECODER = '📦 VAE Model Decoder',
  MODEL__T2I = '📦 T2I Model',

  NUMBER__THRESHOLD_COLOR = '🎛️ Threshold Color',

  TILE_SIZE = '📏 Tile Size',

  UNKNOWN = '',
}
